import { Navigate, Route, Routes } from 'react-router';
import { LoadingScreen } from '../components/atoms/LoadingScreen';
import { LoginScreen } from '../screens/Login/LoginScreen';
import { PublicDocScreen } from '../screens/Public/PublicDocScreen';
import { PublicMoneyCollectionScreen } from '../screens/Public/PublicMoneyCollectionSreen';
import { PATHS } from './data';

export const PublicNavigator = () => {
  return (
    <Routes>
      <Route path={PATHS.HOME} element={<LoginScreen />} />
      <Route path={`${PATHS.SHARED_DOC}/:id`} element={<PublicDocScreen />} />
      <Route path={`${PATHS.SHARED_MONEY_COLLECTION}/:id`} element={<PublicMoneyCollectionScreen />} />
      <Route path={PATHS.LOADING} element={<LoadingScreen />} />
      <Route path="*" element={<Navigate to={PATHS.HOME} replace />} />
    </Routes>
  );
};
